(function () {
  'use strict';

  var header = document.querySelector('[data-header-livuno]');
  if (!header) return;

  var drawer = header.querySelector('[data-drawer]');
  var toggle = header.querySelector('[data-drawer-toggle]');

  /* Move drawer to <body> to escape any parent stacking context
     (Shrine sections may have transform/sticky/z-index that traps position:fixed
     and lets sibling sections like Info Bar render on top of the drawer) */
  if (drawer && drawer.parentElement !== document.body) {
    document.body.appendChild(drawer);
  }

  var closeEls = drawer ? drawer.querySelectorAll('[data-drawer-close]') : [];

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('header-livuno-drawer-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('header-livuno-drawer-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  if (toggle && drawer) {
    toggle.addEventListener('click', function () {
      if (drawer.classList.contains('is-open')) closeDrawer();
      else openDrawer();
    });
  }

  closeEls.forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  /* Cart count live update */
  function updateCartCount(count) {
    var el = header.querySelector('[data-cart-count]');
    if (!el) return;
    el.textContent = count;
    if (count > 0) el.classList.remove('is-empty');
    else el.classList.add('is-empty');
  }

  /* Refresh on cart updates from other scripts */
  document.addEventListener('cart:refresh', function () {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  });

  /* Listen to Shopify Section rendering API (theme editor preview) */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector('[data-header-livuno]')) {
      /* Re-init happens automatically since script re-runs on section reload */
    }
  });
})();
